// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__21OCb","checkboxCol":"Table_checkboxCol__1_OO4","emailCol":"Table_emailCol__BoqdF","actionCol":"Table_actionCol__2GFb0"};